/* eslint-disable */
// This file needs verification, to see, uncomment line above
import React from "react";
import { JoiningPage } from "translations/src/models/joining-pages";
import { IGenderOptionsTranslations } from "translations/src/models/joining-pages/AboutYouPage";

import { useTranslations } from "./useTranslations";

export const NON_BINARY_FACET_ID = 5207;

export const CUSTOM_FACET_ID = 5208;

export const TRANSGENDER_MALE_FACET_ID = 5205;

export const TRANSGENDER_FEMALE_FACET_ID = 5206;

interface AdditionalGenderOption {
  value: number;
  label: string;
  description: string;
}

export const useAdditionalGenderOptions = (genderFacetId?: number | null) => {
  const [options, setOptions] = React.useState<AdditionalGenderOption[]>([]);
  const showNonBinary = genderFacetId === NON_BINARY_FACET_ID;
  const showCustom = genderFacetId === CUSTOM_FACET_ID;
  const showOptions = showNonBinary || showCustom;

  const {
    texts: { genderOptions: genderOptionTexts },
  } = useTranslations(JoiningPage.AboutYouPage);

  React.useEffect(() => {
    if (!genderFacetId) return;

    let genderOptions: AdditionalGenderOption[] = [];

    if (genderFacetId === NON_BINARY_FACET_ID) {
      genderOptions = createNonBinaryGenderOptions(genderOptionTexts);
    } else if (genderFacetId === CUSTOM_FACET_ID) {
      genderOptions = createCustomGenderOptions(genderOptionTexts);
    }

    setOptions(genderOptions);
  }, [genderFacetId, genderOptionTexts]);

  return {
    additionalGenderOptions: options,
    showOptions,
  };
};

const createNonBinaryGenderOptions = (texts: IGenderOptionsTranslations) => [
  {
    value: 558,
    label: texts.nonBinaryPerformersOnly,
    description: texts.nonBinaryPerformersOnlyDesc,
  },
  {
    value: 559,
    label: texts.nonBinaryMaleAndFemale,
    description: texts.nonBinaryMaleAndFemaleDesc,
  },
  {
    value: 560,
    label: texts.nonBinaryFemaleOnly,
    description: texts.nonBinaryFemaleOnlyDesc,
  },
  {
    value: 561,
    label: texts.nonBinaryMaleOnly,
    description: texts.nonBinaryMaleOnlyDesc,
  },
];

const createCustomGenderOptions = (texts: IGenderOptionsTranslations) => [
  {
    value: 558,
    label: texts.customPerformersOnly,
    description: texts.customPerformersOnlyDesc,
  },
  {
    value: 559,
    label: texts.customMaleAndFemale,
    description: texts.customMaleAndFemaleDesc,
  },
  {
    value: 560,
    label: texts.customFemaleOnly,
    description: texts.customFemaleOnlyDesc,
  },
  {
    value: 561,
    label: texts.customMaleOnly,
    description: texts.customMaleOnlyDesc,
  },
];

export const displayTransgenderDescription = (
  genderFacetId?: number | null
) => {
  const showTransgenderDescription =
    genderFacetId === TRANSGENDER_MALE_FACET_ID ||
    genderFacetId === TRANSGENDER_FEMALE_FACET_ID;

  const {
    texts: { mainPage: mainPagenTexts },
  } = useTranslations(JoiningPage.AboutYouPage);

  const transgenderDescription =
    genderFacetId === TRANSGENDER_MALE_FACET_ID
      ? mainPagenTexts.transgenderMaleDesc
      : mainPagenTexts.transgenderFemaleDesc;

  React.useEffect(() => {
    if (!genderFacetId) return;
  }, [genderFacetId, mainPagenTexts]);

  return {
    transgenderDescription,
    showTransgenderDescription,
  };
};
